import Axios from 'axios';
import { useMutation } from '@tanstack/vue-query';

export default function useAddToCartMutation() {
  return useMutation({
    mutationFn: async ({ productId, quantity }) => {
      const formData = new FormData();
      formData.append('productId', productId);
      formData.append('quantity', quantity);

      const response = await Axios.post('/api/cart/item/', formData);
      return response.data;
    },
  });
}
